import { render, staticRenderFns } from "./navigation-menu-item.component.vue?vue&type=template&id=5996d152&scoped=true"
import script from "./navigation-menu-item.component.vue?vue&type=script&lang=ts"
export * from "./navigation-menu-item.component.vue?vue&type=script&lang=ts"
import style0 from "./navigation-menu-item.component.vue?vue&type=style&index=0&id=5996d152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996d152",
  null
  
)

export default component.exports